import { useQuery } from '@connectrpc/connect-query';

import { getMe } from '@/gen/user/v1/user-UserService_connectquery';

export const useCurrentUser = () => {
	const { data, isLoading, isError, refetch } = useQuery(
		getMe,
		{},
		{ staleTime: Infinity, retry: false },
	);

	return { user: data?.user, isLoading, isError, refetch };
};
